"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends")),
    _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty")),
    _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties")),
    _react = _interopRequireDefault(require("react")),
    _lodash = _interopRequireDefault(require("lodash.memoize")),
    _commentsContext = _interopRequireDefault(require("../../../contexts/commentsContext")),
    _Comment = _interopRequireDefault(require("../components/Comment")),
    _Uploader = require("../../../../Uploader");

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var source, i = 1; i < arguments.length; i++) {
    source = null == arguments[i] ? {} : arguments[i], i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2["default"])(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var handleSelectComment = (0, _lodash["default"])(function (comment, onSelectComment) {
  return function () {
    return onSelectComment(comment);
  };
});

function CommentContainer(_ref) {
  var comment = _ref.comment,
      commentIndex = _ref.commentIndex,
      getCommentTitle = _ref.getCommentTitle,
      isGroupSelected = _ref.isGroupSelected,
      onSelectComment = _ref.onSelectComment,
      isCommentSelected = _ref.isCommentSelected,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["comment", "commentIndex", "getCommentTitle", "isGroupSelected", "onSelectComment", "isCommentSelected"]);
  return _react["default"].createElement(_commentsContext["default"].Consumer, null, function (_ref2) {
    var canResolveComment = _ref2.state.canResolveComment,
        _ref2$actions = _ref2.actions,
        updateComment = _ref2$actions.updateComment,
        getUserColor = _ref2$actions.getUserColor,
        deleteComment = _ref2$actions.deleteComment;
    return _react["default"].createElement(_Uploader.AssetsSelector, {
      assetIds: comment.assetIds || []
    }, function (assets) {
      return _react["default"].createElement(_Comment["default"], (0, _extends2["default"])({
        commentIndex: commentIndex,
        comment: _objectSpread({}, comment, {
          assets: assets
        }),
        canResolveComment: canResolveComment,
        getCommentTitle: getCommentTitle,
        getUserColor: getUserColor,
        isGroupSelected: isGroupSelected,
        isCommentSelected: isCommentSelected,
        onSelectComment: handleSelectComment(comment, onSelectComment),
        updateComment: updateComment,
        deleteComment: deleteComment
      }, props));
    });
  });
}

var _default = CommentContainer;
exports["default"] = _default;